import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ISipPhoneConfiguration } from '@obvious.tech/constellation'

export const SipPhoneConfiguration = defineEntity('SipPhoneConfiguration', {
  endpoint: 'sip/api/SipPhoneConfiguration',
  schema: SNoop<ISipPhoneConfiguration>(),
})
